module.exports = __webpack_public_path__ + "static/media/messages.44b00130.png";